module.exports = "table {\n  width: 100%; }\n\ntd {\n  text-align: left; }\n"